"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var routing = {
    "base_url": "",
    "routes": {
        "api_parameters_get_themes_for_mobile": {
            "tokens": [
                [
                    "text",
                    "/theme/all-title-ids"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        }, "api_parameters_get_themes_with_children": {
            "tokens": [
                [
                    "text",
                    "/theme/all-title-ids-with-children"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        }, "api_media_get_list_on_going_videos": {
            "tokens": [
                [
                    "text",
                    "/video/videos/on-going-videos"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        }, "api_media_get_list_on_going_videos_by_themes": {
            "tokens": [
                [
                    "text",
                    "/video/videos/on-going-videos-by-themes"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_subscription_user_post_subscription_mail_pwd": {
            "tokens": [
                [
                    "text",
                    "/subscription_user/subscription-mail-pwd"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_subscription_user_post_change_pwd": {
            "tokens": [
                [
                    "text",
                    "/subscription_user/change-pwd"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_list_on_going_videos_all_custom": {
            "tokens": [
                [
                    "text",
                    "/video/videos/on-going-videos-all-custom"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_video_custom": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/get-video"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_subscription_user_get_ip_intranet": {
            "tokens": [
                [
                    "text",
                    "/subscription_user/ip-intranet-subscriber"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_get_stats_videos_by_themes": {
            "tokens": [
                [
                    "text",
                    "/stats/mooc/stats-videos-by-theme"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_list_quiz_by_theme": {
            "tokens": [
                [
                    "text",
                    "/list-quiz"
                ],
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/rich_media/theme"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "post_login": {
            "tokens": [
                [
                    "text",
                    "/global/log"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_subscription_user_subscription_mail": {
            "tokens": [
                [
                    "text",
                    "/subscription_user/subscription-mail"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_profiles_send_mail_since_contact_form": {
            "tokens": [
                [
                    "text",
                    "/profiles/mail/send"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_crypted_player_string": {
            "tokens": [
                [
                    "text",
                    "/video/video/crypt-url"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_crypted_player_playlist_string": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/playlist/playlist-link"
                ],
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_videos_by_home_conf": {
            "tokens": [
                [
                    "text",
                    "/video/videos-by-home-conf"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_subscription_user_authentification": {
            "tokens": [
                [
                    "text",
                    "/subscription_user/authentification"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_add_certificate": {
            "tokens": [
                [
                    "text",
                    "/mooc/add-certificate"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_get_stats_options": {
            "tokens": [
                [
                    "text",
                    "/mooc/stats-options"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_post_mooc_number_visa_by_user": {
            "tokens": [
                [
                    "text",
                    "/stats/mooc/number-visa-by-user"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_post_mooc_number_passeport_by_user": {
            "tokens": [
                [
                    "text",
                    "/stats/mooc/number-passeport-by-user"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_post_last_response_before_destroy": {
            "tokens": [
                [
                    "text",
                    "/stats/mooc/last-response-before-destroy"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_subscription_user_post_add_user": {
            "tokens": [
                [
                    "text",
                    "/subscription_user/add"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_video_by_id": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/video_by_id"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_video_info": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/get-video-info"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_parameters_get_themes_children": {
            "tokens": [
                [
                    "text",
                    "/theme/themes-children"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_get_infos_profile_user": {
            "tokens": [
                [
                    "text",
                    "/stats/mooc/profiles/infos-user"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_list_on_going_videos_custom": {
            "tokens": [
                [
                    "text",
                    "/video/videos/on-going-videos-custom"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_mooc_get_stats_themes_by_channels": {
            "tokens": [
                [
                    "text",
                    "/stats/mooc/stats-themes-by-canal"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_parameters_get_themes_children_per_canal": {
            "tokens": [
                [
                    "text",
                    "/theme/themes-children-per-canal"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_list_quiz_by_theme_parent": {
            "tokens": [
                [
                    "text",
                    "/list-quiz-by-parent-theme"
                ],
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/rich_media/theme"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_news_get_latest_news": {
            "tokens": [
                [
                    "text",
                    "/news/latest-news"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_post_add_quiz_responses": {
            "tokens": [
                [
                    "text",
                    "/rich_media/add-quiz-response"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_crypted_player_string_custom": {
            "tokens": [
                [
                    "text",
                    "/video/video/crypt-url-custom"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_dtable_list_dtable_videos_ongoing": {
            "tokens": [
                [
                    "text",
                    "/dataTable/videos/ongoing"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_dtable_list_dtable_videos_exceed": {
            "tokens": [
                [
                    "text",
                    "/dataTable/videos/archived-exceed"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_params_url_list_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "[a-zA-Z0-9_+\\.=-]+",
                    "crypttext"
                ],
                [
                    "text",
                    "/video/video/get-params-url-list-video"
                ]
            ],
            "defaults": [],
            "requirements": {
                "crypttext": "[a-zA-Z0-9_+\\.=-]+"
            },
            "hosttokens": []
        },
        "api_dtable_list_dtable_videos": {
            "tokens": [
                [
                    "text",
                    "/dataTable/videos/all"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_dtable_list_dtable_videos_offline": {
            "tokens": [
                [
                    "text",
                    "/dataTable/videos/offline"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_dtable_list_dtable_videos_archived": {
            "tokens": [
                [
                    "text",
                    "/dataTable/videos/archived"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_dtable_list_dtable_videos_upcoming": {
            "tokens": [
                [
                    "text",
                    "/dataTable/videos/upcoming"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_dtable_list_dtable_lives_archived": {
            "tokens": [
                [
                    "text",
                    "/dataTable/lives/archived"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_parameters_get_channels_group_by_themes": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "[^/]++",
                    "ids"
                ],
                [
                    "text",
                    "/channel/channel-by-themes"
                ]
            ],
            "defaults": {
                "ids": null
            },
            "requirements": [],
            "hosttokens": []
        },
        "api_parameters_get_channels_names": {
            "tokens": [
                [
                    "text",
                    "/channel/names"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_parameters_get_themes_names": {
            "tokens": [
                [
                    "text",
                    "/theme/names"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_contributors": {
            "tokens": [
                [
                    "text",
                    "/video/videos/contributors/list"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_multi_delete_videos": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "[^/]++",
                    "ids"
                ],
                [
                    "text",
                    "/multiDelete/videos"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_core_rights_get_user_rights": {
            "tokens": [
                [
                    "text",
                    "/core/rights/get-user-rights"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        }, "api_media_get_number_visits": {
            "tokens": [
                [
                    "text",
                    "/video/video/number-visits"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_post_check_if_videos_are_done_transoding": {
            "tokens": [
                [
                    "text",
                    "/video/video/are-they-done-transcoding"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_post_enable_push_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/enable-push-video"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_post_disable_push_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/disable-push-video"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_post_toggle_video_by_type": {
            "tokens": [
                [
                    "text",
                    "/video/toggle-video-by-type"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_delete_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/delete"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_archivate_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/archivate"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_archivate_videos": {
            "tokens": [
                [
                    "text",
                    "/video/archivate-videos"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_restore_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/restore"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_video_url": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/video/url-export"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_live_url": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/lives/link_export"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_getlink_export_by_stream_name": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "streamName"
                ],
                [
                    "text",
                    "/lives/link-export-by-stream-name"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_parameters_get_detail_theme": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/theme"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_links_social_medias": {
            "tokens": [
                [
                    "text",
                    "/video/video/links-social-medias"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_associated_videos": {
            "tokens": [
                [
                    "text",
                    "/video/video/associated-videos"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_videos_most_visited": {
            "tokens": [
                [
                    "text",
                    "/video/video/most-visited"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_get_current_live": {
            "tokens": [
                [
                    "text",
                    "/lives/get-current-live"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_check_existence_live_today": {
            "tokens": [
                [
                    "text",
                    "/lives/check-exist-live-today"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_add_home_page_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/add-homePage-video"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_delete_home_page_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/delete-homePage-video"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_log": {
            "tokens": [
                [
                    "text",
                    "/global/log"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_get_lives_live_detail": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/lives/lives-live"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_get_live_detail_by_stream_name": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "streamName"
                ],
                [
                    "text",
                    "/lives/live-detail-by-stream-name"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_decrypted_infos": {
            "tokens": [
                [
                    "text",
                    "/video/video/decrypt/infos"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_player_infos": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "[^/]++",
                    "id"
                ],
                [
                    "text",
                    "/video/video/player/infos"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_parameters_get_themes_choices_for_select_input": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+|all",
                    "idToIgnore"
                ],
                [
                    "text",
                    "/theme/select-choices"
                ]
            ],
            "defaults": {
                "idToIgnore": "0"
            },
            "requirements": {
                "idToIgnore": "\\d+|all"
            },
            "hosttokens": []
        },
        "api_stats_acces_post_add_stats_acces": {
            "tokens": [
                [
                    "text",
                    "/stats/acces_send"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_get_list_pdf": {
            "tokens": [
                [
                    "text",
                    "/pdf/list"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_post_save_setting_video": {
            "tokens": [
                [
                    "text",
                    "/video/video/save-setting-video"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_post_set_default_skin_video": {
            "tokens": [
                [
                    "text",
                    "/video/video/set-default-skin-video"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_params_get_detail_param": {
            "tokens": [
                [
                    "text",
                    "/param"
                ],
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/param/details"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_video_preview_link_by_token": {
            "tokens": [
                [
                    "variable",
                    "/",
                    ".+",
                    "token"
                ],
                [
                    "text",
                    "/video/video/preview-link-by-token"
                ]
            ],
            "defaults": [],
            "requirements": {
                "token": ".+"
            },
            "hosttokens": []
        },
        api_get_user_params: {
            tokens: [
                [
                    'text',
                    '/videos/params-live'
                ]
            ],
            defaults: [],
            requirements: [],
            hosttokens: [],
        },
        "api_post_vote_by_user_and_video": {
            "tokens": [
                [
                    "text",
                    "/likes_video/vote-by-user-and-video"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_post_average_and_number_user_vote_video": {
            "tokens": [
                [
                    "text",
                    "/likes_video/average-user-vote-video"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_download_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/download"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        "api_media_get_video_preview_link": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "\\d+",
                    "id"
                ],
                [
                    "text",
                    "/video/video/preview-link"
                ]
            ],
            "defaults": [],
            "requirements": {
                "id": "\\d+"
            },
            "hosttokens": []
        },
        api_contact_us: {
            tokens: [
                [
                    "text",
                    "/contact-us"
                ]
            ],
            defaults: [],
            requirements: [],
            hosttokens: []
        },
        "api_media_exist_token_video": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "[^/]++",
                    "token"
                ],
                [
                    "text",
                    "/video/exist-token-video"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_send_video_by_id_via_mail": {
            "tokens": [
                [
                    "text",
                    "/video/video/send-video-by-id-via-email"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_post_add_edit_event_calendar": {
            "tokens": [
                ["text",
                    "/lives/add-edit-event-calendar"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_ws_contact_send_mail_since_contact_form_f_o": {
            "tokens": [
                [
                    "text",
                    "/ws/contact/mail/send/form"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_write_log": {
            "tokens": [
                [
                    "text",
                    "/global/write-log"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_verif_secure_token_fo": {
            "tokens": [
                [
                    "variable",
                    "/",
                    "[^/]++",
                    "token"
                ],
                [
                    "text",
                    "/verif-secure-token-fo"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
        "api_media_get_videos_most_liked": {
            "tokens": [
                [
                    "text",
                    "/video/video/most-liked"
                ]
            ],
            "defaults": [],
            "requirements": [],
            "hosttokens": []
        },
    },
    "prefix": "",
    "host": "localhost",
    "scheme": "http"
};
exports.default = routing;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuex-service-api/dist/router/fos_js_routes_export.js
// module id = GLfa
// module chunks = 0